import {SiteBasics} from 'Common/SiteBasics';
import Assert from 'Common/Assert';
import {ArtistRoutes} from 'Common/artists/ArtistRoutes';
import {AdminRoutes} from 'Shared/admin/AdminRoutes';
import {VenueSettingsFactory} from 'Shared/VenueSettingsFactory';
import {SiteType} from 'Common/SiteType';
import { BrowserId } from 'Browser/BrowserId';
import { defaultVenueSettings } from 'Shared/model/venueSettings';


export function selectRoutes(site:SiteBasics<BrowserId>)
{
	switch(site.type) {
		case SiteType.venue:	
			/* Routing doesn't depend on the venue's colours, and the venue document isn't loaded
			   this early, so any settings will do here. */
			const settings = (new VenueSettingsFactory()).createSettings(site.key,defaultVenueSettings);
			const routerClass = settings.routes();
			return (new routerClass(settings.pages())).routes();

		case SiteType.artist:
			return (new ArtistRoutes()).routes();

		case SiteType.admin:
			return (new AdminRoutes()).routes();
	}
console.log('RoutesSelector site.type:',site.type);	
	Assert.check(false);
}

